module.exports = __webpack_public_path__ + "img/16-04_Focusing On Customers.67145c91.svg";